import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MapPin, Grid3x3, List } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function UserCouponGrid({ filteredCoupons, viewMode, setViewMode }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-slate-900">Cupons Disponiveis</h2>
        <div className="flex gap-2">
          <Button variant={viewMode === 'grid' ? 'default' : 'outline'} size="sm" onClick={() => setViewMode('grid')}
            className={viewMode === 'grid' ? 'bg-slate-600 hover:bg-slate-700 border-slate-600' : 'border-slate-400 hover:bg-slate-100'} data-testid="grid-view-btn">
            <Grid3x3 className="h-4 w-4" />
          </Button>
          <Button variant={viewMode === 'list' ? 'default' : 'outline'} size="sm" onClick={() => setViewMode('list')}
            className={viewMode === 'list' ? 'bg-slate-600 hover:bg-slate-700 border-slate-600' : 'border-slate-400 hover:bg-slate-100'} data-testid="list-view-btn">
            <List className="h-4 w-4" />
          </Button>
        </div>
      </div>
      {filteredCoupons.length === 0 ? (
        <Card className="hero-card"><CardContent className="py-12 text-center"><p className="text-slate-200">Nenhum cupom encontrado</p></CardContent></Card>
      ) : viewMode === 'grid' ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCoupons.map(coupon => (
            <Card key={coupon.coupon_id} className="coupon-card hero-card cursor-pointer hover:border-slate-400 hover:shadow-lg transition-all"
              onClick={() => navigate(`/coupons/${coupon.coupon_id}`)} data-testid={`coupon-${coupon.coupon_id}`}>
              {coupon.images?.length > 0 && (
                <div className="w-full aspect-[4/3] overflow-hidden rounded-t-md">
                  <img src={coupon.images[0]} alt={coupon.title} className="w-full h-full object-cover" />
                </div>
              )}
              <CardHeader>
                <div className="flex justify-between items-start mb-2">
                  <Badge className="bg-white/20 text-white border-white/30">{coupon.discount_percentage}% OFF</Badge>
                  <Badge className="bg-white/20 text-white border-white/30 text-xs">{coupon.category}</Badge>
                </div>
                <CardTitle className="text-base sm:text-xl text-white">{coupon.title}</CardTitle>
                <CardDescription className="line-clamp-2 text-slate-200">{coupon.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-sm text-slate-200"><MapPin className="h-4 w-4" /> {coupon.city}, {coupon.state}</div>
                  <div className="flex justify-between items-center">
                    <p className="text-xs text-slate-300">Expira: {new Date(coupon.expires_at).toLocaleDateString('pt-BR')}</p>
                    {coupon.max_uses === 1 && <Badge className="bg-red-500/80 text-white border-transparent text-xs">Uso Unico</Badge>}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {filteredCoupons.map(coupon => (
            <Card key={coupon.coupon_id} className="coupon-card hero-card cursor-pointer hover:border-slate-400 hover:shadow-lg transition-all"
              onClick={() => navigate(`/coupons/${coupon.coupon_id}`)} data-testid={`coupon-list-${coupon.coupon_id}`}>
              <CardContent className="py-4">
                <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
                  {coupon.images?.length > 0 && (
                    <div className="w-full sm:w-24 h-32 sm:h-24 overflow-hidden rounded-md border border-white/20 shrink-0">
                      <img src={coupon.images[0]} alt={coupon.title} className="w-full h-full object-cover" />
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 sm:gap-3 mb-2 flex-wrap">
                      <Badge className="bg-white/20 text-white border-white/30 text-xs">{coupon.discount_percentage}% OFF</Badge>
                      <Badge className="bg-white/20 text-white border-white/30 text-xs">{coupon.category}</Badge>
                      {coupon.max_uses === 1 && <Badge className="bg-red-500/80 text-white border-transparent text-xs">Uso Unico</Badge>}
                    </div>
                    <h3 className="text-base sm:text-xl font-bold text-white mb-1">{coupon.title}</h3>
                    <p className="text-sm text-slate-200 mb-3 line-clamp-2">{coupon.description}</p>
                    <div className="flex flex-wrap gap-2 sm:gap-4 text-xs text-slate-300">
                      <div className="flex items-center gap-1"><MapPin className="h-3 w-3" /><span>{coupon.city}, {coupon.state}</span></div>
                      <span>Exp: {new Date(coupon.expires_at).toLocaleDateString('pt-BR')}</span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
